import * as api from '../../api/equityFinder/dashboard';
import { makeApiActionCreatorV3 } from '../utils';

export const APPRAISER_STATUS_FETCH_START =
  'DASHBOARD/APPRAISER_STATUS_FETCH_START';
export const APPRAISER_STATUS_FETCH_SUCCESS =
  'DASHBOARD/APPRAISER_STATUS_FETCH_SUCCESS';
export const APPRAISER_STATUS_FETCH_ERROR =
  'DASHBOARD/APPRAISER_STATUS_FETCH_ERROR';

export const APPRAISERS_FETCH_START = 'DASHBOARD/APPRAISERS_FETCH_START';
export const APPRAISERS_FETCH_SUCCESS = 'DASHBOARD/APPRAISERS_FETCH_SUCCESS';
export const APPRAISERS_FETCH_ERROR = 'DASHBOARD/APPRAISERS_FETCH_ERROR';

export const APPRAISER_CASE_FETCH_START =
  'DASHBOARD/APPRAISER_CASE_FETCH_START';
export const APPRAISER_CASE_FETCH_SUCCESS =
  'DASHBOARD/APPRAISER_CASE_FETCH_SUCCESS';
export const APPRAISER_CASE_FETCH_ERROR =
  'DASHBOARD/APPRAISER_CASE_FETCH_ERROR';

export const RECENT_EDITS_FETCH_START = 'DASHBOARD/RECENT_EDITS_FETCH_START';
export const RECENT_EDITS_FETCH_SUCCESS =
  'DASHBOARD/RECENT_EDITS_FETCH_SUCCESS';
export const RECENT_EDITS_FETCH_ERROR = 'DASHBOARD/RECENT_EDITS_FETCH_ERROR';

export const HOT_LIST_FETCH_START = 'DASHBOARD/HOT_LIST_FETCH_START';
export const HOT_LIST_FETCH_SUCCESS = 'DASHBOARD/HOT_LIST_FETCH_SUCCESS';
export const HOT_LIST_FETCH_ERROR = 'DASHBOARD/HOT_LIST_FETCH_ERROR';

export const PROTEST_FETCH_START = 'DASHBOARD/PROTEST_FETCH_START';
export const PROTEST_FETCH_SUCCESS = 'DASHBOARD/PROTEST_FETCH_SUCCESS';
export const PROTEST_FETCH_ERROR = 'DASHBOARD/PROTEST_FETCH_ERROR';

export const TIME_LINES_FETCH_START = 'DASHBOARD/TIME_LINES_FETCH_START';
export const TIME_LINES_FETCH_SUCCESS = 'DASHBOARD/TIME_LINES_FETCH_SUCCESS';
export const TIME_LINES_FETCH_ERROR = 'DASHBOARD/TIME_LINES_FETCH_ERROR';

export const TIME_LINE_FETCH_START = 'DASHBOARD/TIME_LINE_FETCH_START';
export const TIME_LINE_FETCH_SUCCESS = 'DASHBOARD/TIME_LINE_FETCH_SUCCESS';
export const TIME_LINE_FETCH_ERROR = 'DASHBOARD/TIME_LINE_FETCH_ERROR';

export const EVIDENCE_FETCH_START = 'DASHBOARD/EVIDENCE_FETCH_START';
export const EVIDENCE_FETCH_SUCCESS = 'DASHBOARD/EVIDENCE_FETCH_SUCCESS';
export const EVIDENCE_FETCH_ERROR = 'DASHBOARD/EVIDENCE_FETCH_ERROR';

export const CHANGE_CURRENT_APPRAISER = 'GLOBAL/CHANGE_CURRENT_APPRAISER';
export const CHANGE_CURRENT_SUPERVISOR = 'GLOBAL/CHANGE_CURRENT_SUPERVISOR';
export const TOGGLE_RECENT_ITEMS = 'GLOBAL/TOGGLE_RECENT_ITEMS';

export const fetchAppraiserStatus = makeApiActionCreatorV3(
  api.fetchAppraiserStatus,
  APPRAISER_STATUS_FETCH_START,
  APPRAISER_STATUS_FETCH_SUCCESS,
  APPRAISER_STATUS_FETCH_ERROR,
);
export const fetchAppraisers = makeApiActionCreatorV3(
  api.fetchAppraisers,
  APPRAISERS_FETCH_START,
  APPRAISERS_FETCH_SUCCESS,
  APPRAISERS_FETCH_ERROR,
);
export const fetchAppraiserCase = makeApiActionCreatorV3(
  api.fetchAppraiserCase,
  APPRAISER_CASE_FETCH_START,
  APPRAISER_CASE_FETCH_SUCCESS,
  APPRAISER_CASE_FETCH_ERROR,
);
export const fetchRecentEdits = makeApiActionCreatorV3(
  api.fetchRecentEdits,
  RECENT_EDITS_FETCH_START,
  RECENT_EDITS_FETCH_SUCCESS,
  RECENT_EDITS_FETCH_ERROR,
);
export const fetchHotList = makeApiActionCreatorV3(
  api.fetchHotList,
  HOT_LIST_FETCH_START,
  HOT_LIST_FETCH_SUCCESS,
  HOT_LIST_FETCH_ERROR,
);
export const fetchProtest = makeApiActionCreatorV3(
  api.fetchProtest,
  PROTEST_FETCH_START,
  PROTEST_FETCH_SUCCESS,
  PROTEST_FETCH_ERROR,
);
export const fetchTimeLines = makeApiActionCreatorV3(
  api.fetchTimeLines,
  TIME_LINES_FETCH_START,
  TIME_LINES_FETCH_SUCCESS,
  TIME_LINES_FETCH_ERROR,
);
export const fetchTimeLine = makeApiActionCreatorV3(
  api.fetchTimeLine,
  TIME_LINE_FETCH_START,
  TIME_LINE_FETCH_SUCCESS,
  TIME_LINE_FETCH_ERROR,
);
export const fetchEvidence = makeApiActionCreatorV3(
  api.fetchEvidence,
  EVIDENCE_FETCH_START,
  EVIDENCE_FETCH_SUCCESS,
  EVIDENCE_FETCH_ERROR,
);

export function changeCurrentAppraiser(id) {
  return { type: CHANGE_CURRENT_APPRAISER, data: id };
}

export function changeCurrentSupervisor(id) {
  return { type: CHANGE_CURRENT_SUPERVISOR, data: id };
}

export function toggleRecentItems() {
  return { type: TOGGLE_RECENT_ITEMS };
}
